import "jquery.repeater"
import Swal from "sweetalert2"


$(document).ready(function () {
    "use strict";

    // resources/views/users/invite.blade.php:47
    $(".invite-users-email-repeater").repeater({
        initEmpty: false,
        isFirstItemUndeletable: true,
        defaultValues: {},
        show: function () {
            $(this).slideDown()
        },
        hide: function (deleteElement) {
            Swal.fire({
                title: 'Delete email address',
                text: 'Are you sure you want to delete this email address?',
                icon: 'question',
                showCancelButton:true,
                confirmButtonText: '<i class="label-icon bx bx-trash"></i> Delete',
                confirmButtonClass: 'btn btn-label btn-danger btn-min-width',
                cancelButtonText: '<i class="label-icon bx bx-arrow-back"></i> Cancel',
                cancelButtonClass: 'btn btn-label btn-primary btn-min-width',
            }).then((result) => {
                if (result.value === true) {
                    $(this).slideUp(deleteElement);
                }
            })
        },
    })

});
